export const BI_ERRORS = {
  unhandled: {
    rejection: {
      id: 1503,
      name: 'unhandled.rejection',
      error(): never {
        throw new Error(this.name);
      },
    },
  },
  bi: {
    send: {
      id: 1504,
      name: 'bi.send',
      error(): never {
        throw new Error(this.name);
      },
    },
  },
  init: {
    getExperiments: {
      id: 1511,
      name: 'init.getExperiments',
      error(): never {
        throw new Error(this.name);
      },
    },
  },
  fileManager: {
    unknownFileActionHandler: {
      id: 1702,
      name: 'fileManager.unknownFileActionHandler',
    },
    fileMetadata: { id: 1703, name: 'fileManager.fileMetadata' },
    videoInfoPreview: { id: 1704, name: 'fileManager.videoInfoPreview' },
    fileActionExpectedAFile: {
      id: 1705,
      name: 'fileManager.fileActionExpectedAFile',
    },
    fileActionExpectedFilesForUpload: {
      id: 1706,
      name: 'fileManager.fileActionExpectedFilesForUpload',
    },
    getDownloadUrlRequestFailed: {
      id: 1707,
      name: 'fileManager.getDownloadUrlRequestFailed',
    },
  },
  fileManagerComponent: {
    createFolder: { id: 2001, name: 'fileManagerComponent.createFolder' },
  },
  compressFlow: {
    compressFiles: { id: 2101, name: 'compressFlow.compressFiles' },
  },
  jobs: {
    jobStatusCheckTryFailed: { id: 1901, name: 'jobs.jobStatusCheckTryFailed' },
    jobStatusCheckFailed: { id: 1902, name: 'jobs.jobStatusCheckFailed' },
  },
  applications: {
    pageDataLoading: { id: 1801, name: 'applications.pageDataLoading' },
    projectOverviewLoading: {
      id: 1802,
      name: 'applications.projectOverviewLoading',
    },
  },
  flows: {
    projectOverviewLoading: { id: 1803, name: 'flows.projectOverviewLoading' },
  },
  teamMembers: {
    deleteTeamMemberFailed: {
      id: 2201,
      name: 'teamMembers.deleteTeamMemberFailed',
    },
    addTeamMemberFailed: {
      id: 2202,
      name: 'teamMembers.addTeamMemberFailed',
    },
    editTeamMemberFailed: {
      id: 2203,
      name: 'teamMembers.editTeamMemberFailed',
    },
    deleteTeamInvitationsFailed: {
      id: 2206,
      name: 'teamMembers.deleteTeamInvitationsFailed',
    },
  },
  projectOverviewTeamMembers: {
    editMembersListMemberFailed: {
      id: 2204,
      name: 'projectOverviewTeamMembers.editMembersListMemberFailed',
    },
    updateMemberFailed: {
      id: 2205,
      name: 'projectOverviewTeamMembers.updateMemberFailed',
    },
    removeMembersListMemberPermissionsFailed: {
      id: 2207,
      name: 'projectOverviewTeamMembers.removeMembersListMemberPermissionsFailed',
    },
    removeMembersListInvitationPermissionsFailed: {
      id: 2208,
      name: 'projectOverviewTeamMembers.removeMembersListInvitationPermissionsFailed',
    },
    addInvitationToProjectFailed: {
      id: 2209,
      name: 'projectOverviewTeamMembers.addInvitationToProjectFailed',
    },
    addMemberToProjectFailed: {
      id: 2210,
      name: 'projectOverviewTeamMembers.addMemberToProjectFailed',
    },
  },
  projects: {
    addProjectFailed: {
      id: 2211,
      name: 'projects.addProjectFailed',
    },
    deleteProjectFailed: {
      id: 2212,
      name: 'projects.deleteProjectFailed',
    },
  },
};
